import { Menu, MenuItem } from "@mui/material";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import {
  FaCartPlus,
  FaHeart,
  FaSearch,
  FaUser,
  FaClipboardList,
  FaEllipsisV,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import logo from "./Assets/buillogo6.png";
import { DataProvider } from "./ContextProvider";
import PincodeToCity from "./Location";
import LoginDialog from "./LoginDialog";
import { baseurl } from "../config/url";
import UserProfile from "./authcomponents/UserProfile";


const Navbar = () => {
  let {
    isLoginDialogOpen,
    issetLoginDialogOpen,
    setisSignup,
    isSignup,
    setshowotpcomponent,
  } = useContext(DataProvider);
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);

  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const isMoreMenuOpen = Boolean(moreAnchorEl);

  const handleMoreClick = (event) => {
    setMoreAnchorEl(event.currentTarget);
  };

  const handleMoreClose = () => {
    setMoreAnchorEl(null);
  };


  const handleLogin = () => {
    setisSignup(false);
    setshowotpcomponent(false);
    issetLoginDialogOpen(true);
  };

  const handleRegister = () => {
    setisSignup(true);
    setshowotpcomponent(false);
    issetLoginDialogOpen(true);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(
        `${baseurl}/api/seller/get-similar-products?name=${searchTerm}`
      );
      console.log("Response from backend:", response.data);
      navigate("/similar-products", { state: { products: response.data } });
    } catch (error) {
      console.error("Error fetching similar products:", error);
    }
    setSearchTerm("");
  };

  const openWishlist = () => {
    navigate("/wishlist");
  };

  const navigateToOrders = () => {
    navigate("/orders"); // Navigate to the orders page
  };

  

  const handleAccountMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    setShowProfile(true);
    handleMenuClose();
  };

  const handleLogout = () => {
    console.log("Logged out");
    localStorage.removeItem("userId");
    localStorage.removeItem("token");
    localStorage.removeItem("usercredentials");
    localStorage.clear();
    navigate("/");
    handleMenuClose();
  };

  return (
    <>

<UserProfile isSidebarOpen={showProfile} setSidebarOpen={setShowProfile} />
      <LoginDialog
        open={isLoginDialogOpen}
        onClose={() => issetLoginDialogOpen(false)}
        isSignup={isSignup}
        setisSignup={setisSignup}
      />
      <div className="bg-gradient-to-r from-blue-500 to-blue-400 text-white py-2 px-2 sm:px-6">
        <div className="flex justify-between items-center space-y-2 sm:space-y-0">
          <div className="flex space-x-1 items-center">
            <button
              onClick={handleLogin}
              className="text-sm font-semibold text-white hover:underline"
            >
              Login
            </button>
            <span>/</span>
            <button
              onClick={handleRegister}
              className="text-sm font-semibold text-white hover:underline"
            >
              Register
            </button>
          </div>
          <div className="text-center flex items-center">
            <span className="text-sm">
              Want to become a seller?{" "}
              <a
                href="https://buildproseller.ogcs.co.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-200 hover:underline font-semibold"
              >
                Sign up here
              </a>
            </span>
          </div>
        </div>
      </div>

      <nav className="bg-white px-4 py-0 sm:py-3 flex flex-wrap items-center justify-between shadow-md">
        {/* Logo and Pincode */}
        <div className="flex flex-row sm:items-center w-full sm:w-auto space-y-4 sm:space-y-0 sm:space-x-4 ">
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Logo" className="h-10 sm:h-12" />
          </Link>

          <Link
            to="/bulk-request"
            aria-label="Request a bulk quote"
            className="group inline-flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-xs sm:text-sm text-gray-700 hover:text-blue-600 hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
          >
            <span className="text-center">
              Request Quote for Bulk
            </span>
          </Link>

          
          
          <div className="w-full sm:w-auto block sm:hidden">
            <PincodeToCity />
          </div>
        </div>

        {/* Search Bar */}
        <div className="sm:flex sm:justify-center sm:items-center gap-4 w-full sm:w-auto mt-4 sm:mt-0 flex-grow sm:flex-grow-0 sm:ml-4 ">
          <div className="w-full sm:w-auto hidden sm:block">
            <PincodeToCity />
          </div>
          <form onSubmit={handleSearch}>
            <div className="flex items-center w-full rounded-lg">
              <input
                type="text"
                placeholder="Search for products"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full py-2 px-4 h-full rounded-l-lg text-gray-700 placeholder-gray-400 focus:outline-none border border-blue-600 focus:ring-2 focus:ring-blue-600"
              />
              <button
                type="submit"
                className="bg-blue-600 text-white hover:bg-blue-700 px-4 py-2.5 rounded-r-lg flex items-center justify-center"
              >
                <FaSearch className="text-lg" />
              </button>
            </div>
          </form>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-end space-x-4 mt-4 sm:mt-0 w-full lg:w-auto ">
          <button
            className="bg-gray-600 text-white py-2 px-4 rounded-md hover:bg-gray-700 transition flex items-center"
            onClick={navigateToOrders}
          >
            <FaClipboardList className="mr-2" />
          </button>

          <button
            className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition flex items-center"
            onClick={() => navigate("/cart")}
          >
            <FaCartPlus />
          </button>

          <button
            className="bg-transparent text-red-600 p-3 rounded-md hover:bg-red-100 transition flex items-center"
            onClick={openWishlist}
            aria-label="Wishlist"
          >
            <FaHeart className="text-2xl" />
          </button>

          <button
            className="bg-gray-600 text-white p-3 rounded-full hover:bg-gray-700 transition flex items-center justify-center"
            onClick={handleAccountMenuClick}
          >
            <FaUser />
          </button>

          {/* More Dropdown */}
          <div>
            <button
              className="bg-gray-200 text-black p-3 rounded-md hover:bg-gray-300 transition flex items-center justify-center"
              onClick={handleMoreClick}
            >
              <FaEllipsisV />
            </button>
            <Menu
              anchorEl={moreAnchorEl}
              open={isMoreMenuOpen}
              onClose={handleMoreClose}
            >
              {/* <MenuItem
                onClick={() => {
                  navigate("/about");
                  handleMoreClose();
                }}
              >
                About Us
              </MenuItem> */}
              <MenuItem
                onClick={() => {
                  navigate("/blogPage");
                  handleMoreClose();
                }}
              >
                Blogs
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/faq");
                  handleMoreClose();
                }}
              >
                FAQ
              </MenuItem>
            </Menu>
          </div>



          <Menu anchorEl={anchorEl} open={openMenu} onClose={() => setAnchorEl(null)}>
            <MenuItem onClick={handleProfile}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
          
        </div>
      </nav>
    </>
  );
};

export default Navbar;
